module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [(_vm.children && _vm.children.length > 0) ? _c('el-tabs', {
    staticStyle: {
      "width": "1105px"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_vm._l((_vm.children), function(item) {
    return (!item.hidden && !(item.path == 'lock' && !_vm.isPromotorDisplay)) ? _c('el-tab-pane', {
      key: item.path,
      attrs: {
        "label": item.text,
        "name": item.path
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-033f1955","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/AppMain.vue
// module id = 918
// module chunks = 1